import React, { useContext } from 'react';
import { ReferenceArrayInput } from 'react-admin';
import { FormSpy } from 'react-final-form';
import { Grid, Typography, makeStyles } from '@material-ui/core';

import OptionsGrid from './OptionsGrid';
import { DistributionListContext } from './DistributionListContext';
import CustomSimpleForm from '../../../core/components/form/CustomSimpleForm';

const useStyles = makeStyles({
  header: {
    paddingTop: '0px',
    fontSize: 20,
    fontWeight: 600
  },
  description: {
    display: 'flex',
    marginTop: '7px',
    fontSize: 14
  }
});

// Validate we have some contacts selected
// Form level validator
const validateOptions = ({ options }) => {
  const errors = {};
  if (options === undefined || options.length < 1) {
    errors.funds = 'At least one Contact/Contact CC must be selected';
  } else {
    options.forEach(option => {
      if (!option.includeAllPrimary && !option.includeAllWithCC) {
        errors.funds = `For every filter at least one Contact/Contact CC must be selected`;
      }
    });
  }

  return errors;
};

const FundsArrayInput = props => {
  const limitToCall = 50;
  if (props.distributionList.funds.length < limitToCall) {
    if (props.distributionList.funds.length === 1) {
      props.distributionList.funds.push('');
    }
    return (
      <ReferenceArrayInput
        label="Funds"
        resource={props.resource}
        reference="funds"
        source="funds"
        perPage={-1}
        sort={{ field: 'name', order: 'ASC' }}
        filter={{
          id: `[${props.distributionList.funds}]`
        }}
      >
        <OptionsGrid formprops={props.formprops} />
      </ReferenceArrayInput>
    );
  } else {
    return (
      <ReferenceArrayInput
        label="Funds"
        resource={props.resource}
        reference="funds"
        source="funds"
        perPage={-1}
        sort={{ field: 'name', order: 'ASC' }}
      >
        <OptionsArray {...props} formprops={props.formprops} />
      </ReferenceArrayInput>
    );
  }
};

const OptionsArray = props => {
  let preselectedChoices = props.choices.filter(choice =>
    props.distributionList.funds.includes(choice.id)
  );

  return (
    <OptionsGrid
      {...props}
      choices={preselectedChoices}
      formprops={props.formprops}
    />
  );
};

const OptionsStep = props => {
  const { dlContext, setDlContext } = useContext(DistributionListContext);
  const classes = useStyles();

  const { variant, onSubmitEnd, preselectedUsersEmails, userIdList } = props;
  const { distributionList = {}, options = [] } = dlContext;

  const setOptions = async values => {
    var options = values.options;
    if (
      options &&
      preselectedUsersEmails &&
      preselectedUsersEmails.length > 0
    ) {
      options.forEach(o => (o.preselectedUsersEmails = preselectedUsersEmails));
    }
    setDlContext({
      ...dlContext,
      currentForm: undefined,
      options: options
    });
    onSubmitEnd();
  };

  return (
    <CustomSimpleForm
      save={setOptions}
      toolbar={null}
      resource={props.resource}
      variant={variant}
      margin="normal"
      initialValues={{ options: [...options] }}
      validate={validateOptions}
    >
      <FormSpy subscription={{ pristine: true, values: true }}>
        {formprops => {
          if (distributionList.funds.length !== 0 && userIdList.length === 0) {
            let filteredOptions = formprops.values.options.filter(option =>
              distributionList.funds.includes(option.fundId)
            );
            formprops.values.options = filteredOptions;
          }

          // Store current form API object
          if (dlContext.currentForm === undefined) {
            setDlContext({ ...dlContext, currentForm: formprops.form });
          }

          return (
            <Grid container spacing={2}>
              <Grid item>
                <Typography variant="h5" className={classes.header}>
                  Options
                </Typography>
                <span className={classes.description}>
                  Check if you want to Include all Contacts and the CC Contact
                  assigned to the listed Funds, or customize the options for
                  each Fund by clicking Advanced link
                </span>
              </Grid>
              <Grid item xs={12}>
                {Array.isArray(distributionList.funds) &&
                  distributionList.funds.length > 0 &&
                  preselectedUsersEmails &&
                  preselectedUsersEmails.length < 1 && (
                    <FundsArrayInput
                      formprops={formprops}
                      distributionList={distributionList}
                      {...props}
                    />
                  )}
              </Grid>
              <Grid item xs={12}>
                {preselectedUsersEmails && preselectedUsersEmails.length > 0 && (
                  <ReferenceArrayInput
                    label="Funds"
                    resource={props.resource}
                    reference="funds"
                    source="funds"
                    perPage={-1}
                    sort={{ field: 'name', order: 'ASC' }}
                    filter={{
                      userIds:
                        userIdList && userIdList.length > 0
                          ? `[${userIdList}]`
                          : [],
                      chunk: true,
                      getFundsForDistributionList: true
                    }}
                  >
                    <OptionsGrid formprops={formprops} />
                  </ReferenceArrayInput>
                )}
              </Grid>
            </Grid>
          );
        }}
      </FormSpy>
    </CustomSimpleForm>
  );
};

export default OptionsStep;
